/* Filo bildirim tercihleri — yalnız tarayıcıda tutulur (backend tablosu yok).
   Dört kategori; varsayılan hepsi açık. Değişiklik window olayı ile yayılır ki
   açık sekmeler yeniden yüklenmeden uygulasın. */

export const FLEET_NOTIFY_PREFS_KEY = 'fleet-notify-prefs';
export const FLEET_NOTIFY_PREFS_EVENT = 'fleet:notify-prefs-changed';

export const FLEET_NOTIFY_CATEGORIES = {
    DISPATCH: 'dispatch',
    EMERGENCY: 'emergency',
    JOIN_REQUEST: 'joinRequest',
    PAYOUT: 'payout',
    /* Entegratör kanalı ayrı kategori: mağaza onayı operasyon değil TİCARİ karar.
       Aynı kutuya konsaydı, atanmamış paket uyarılarını kapatan filo mağaza
       onaylarını da susturur ve bunu fark etmezdi. */
    INTEGRATION: 'integration',
};

export const FLEET_NOTIFY_CATEGORY_LABELS = {
    dispatch: 'Atanmamış paket ve gecikmeler',
    emergency: 'Kurye acil durum',
    joinRequest: 'Katılma talepleri',
    payout: 'Hakediş ve faturalar',
    integration: 'Entegratör mağazaları',
};

const DEFAULTS = { dispatch: true, emergency: true, joinRequest: true, payout: true, integration: true };

/* Tip → kategori. Bilinmeyen tip DISPATCH sayılır: yeni bir push tipi eklendiğinde
   sessizce kaybolmaktansa en görünür kategoriye düşmesi yeğdir. */
const TYPE_CATEGORY = {
    UnassignedPackage: FLEET_NOTIFY_CATEGORIES.DISPATCH,
    CourierNotFound: FLEET_NOTIFY_CATEGORIES.DISPATCH,
    MaxReassign: FLEET_NOTIFY_CATEGORIES.DISPATCH,
    CourierRegionMissing: FLEET_NOTIFY_CATEGORIES.DISPATCH,
    DelayReminder: FLEET_NOTIFY_CATEGORIES.DISPATCH,

    CourierEmergency: FLEET_NOTIFY_CATEGORIES.EMERGENCY,

    FleetJoinRequest: FLEET_NOTIFY_CATEGORIES.JOIN_REQUEST,

    FleetPaymentCreated: FLEET_NOTIFY_CATEGORIES.PAYOUT,
    FleetPaymentApproved: FLEET_NOTIFY_CATEGORIES.PAYOUT,
    FleetPaymentRejected: FLEET_NOTIFY_CATEGORIES.PAYOUT,
    FleetPaymentPaid: FLEET_NOTIFY_CATEGORIES.PAYOUT,
    FleetInvoiceApproved: FLEET_NOTIFY_CATEGORIES.PAYOUT,
    FleetInvoiceRejected: FLEET_NOTIFY_CATEGORIES.PAYOUT,
    CourierInvoiceUploaded: FLEET_NOTIFY_CATEGORIES.PAYOUT,
    FleetCostUpdated: FLEET_NOTIFY_CATEGORIES.PAYOUT,

    VendorStoreAwaitingApproval: FLEET_NOTIFY_CATEGORIES.INTEGRATION,
    FleetIntegrationChannelChanged: FLEET_NOTIFY_CATEGORIES.INTEGRATION,
};

export function categoryOfType(type) {
    return TYPE_CATEGORY[type] || FLEET_NOTIFY_CATEGORIES.DISPATCH;
}

export function getFleetNotifyPrefs() {
    try {
        const raw = window.localStorage.getItem(FLEET_NOTIFY_PREFS_KEY);
        if (!raw) return { ...DEFAULTS };
        const parsed = JSON.parse(raw);
        const out = { ...DEFAULTS };
        Object.keys(DEFAULTS).forEach((k) => {
            if (typeof parsed[k] === 'boolean') out[k] = parsed[k];
        });
        return out;
    } catch {
        return { ...DEFAULTS };
    }
}

export function setFleetNotifyPrefs(patch) {
    const next = { ...getFleetNotifyPrefs(), ...patch };
    const clean = {};
    Object.keys(DEFAULTS).forEach((k) => { clean[k] = next[k] === true; });
    try {
        window.localStorage.setItem(FLEET_NOTIFY_PREFS_KEY, JSON.stringify(clean));
    } catch { /* kota dolu — tercih uçar, bildirim akışı bozulmaz */ }
    window.dispatchEvent(new CustomEvent(FLEET_NOTIFY_PREFS_EVENT, { detail: clean }));
}
